import {useCommonFilters} from "../../../hooks";
import {useEffect, useState} from "react";

export default function useSavedFiltersState() {
    const { filters } = useCommonFilters()
    const [icon, setIcon] = useState('fal')
    const [open, setOpen] = useState(false)

    const handleClick = () => {
        setIcon(icon === 'fal' ? 'fas' : 'fal')
        setOpen(icon === 'fal')
    }

    const handleClose = newState => {
        setOpen(newState)
        setIcon(!newState && 'fal')
    }

    useEffect(() => {
        setIcon('fal')
    }, [setIcon, JSON.stringify(filters)])

    return {
        handleClose,handleClick, open, icon
    }
}